import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import {
  DropdownMenu as DropdownMenuBase,
  DropdownMenuTrigger as DropdownMenuTriggerBase,
  DropdownMenuContent as DropdownMenuContentBase,
  DropdownMenuItem as DropdownMenuItemBase,
} from './ui/dropdown-menu';

// Os componentes de dropdown-menu.tsx são `// @ts-nocheck` sem generics no
// forwardRef, então o TS infere props vazias pra quem os usa — cast local
// pra desbloquear (mesmo padrão de outros componentes ui/* no projeto).
const DropdownMenu = DropdownMenuBase as any;
const DropdownMenuTrigger = DropdownMenuTriggerBase as any;
const DropdownMenuContent = DropdownMenuContentBase as any;
const DropdownMenuItem = DropdownMenuItemBase as any;

import { SOLUTIONS } from '../data/solutions';
import { ChevronDown } from 'lucide-react';
import { ThemeToggle } from './ThemeToggle';

// Navbar compartilhada entre a landing page e as páginas de solução, pra
// manter a mesma navegação (Sobre, Soluções, Método) em todo o site de marketing.
export const LandingHeader = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-40 border-b bg-background/60 backdrop-blur-xl backdrop-saturate-150 transition-shadow duration-300 ${
        scrolled ? 'border-border shadow-sm' : 'border-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img src="/assets/images/logo.png" alt="Sistema Neurobit" className="h-9 w-auto object-contain" />
          <span className="font-extrabold tracking-tight text-lg">Sistema Neurobit</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          <Link to="/#sobre" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
            Sobre
          </Link>
          <DropdownMenu>
            <DropdownMenuTrigger className="flex items-center gap-1 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors outline-none">
              Soluções
              <ChevronDown size={14} />
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" className="w-64">
              {SOLUTIONS.map((s) => (
                <DropdownMenuItem key={s.slug} asChild>
                  <Link to={`/solucoes/${s.slug}`} className="flex items-start gap-3 cursor-pointer">
                    <s.icon className="text-[#0ba5c6] flex-shrink-0 mt-0.5" size={16} />
                    <span>
                      <span className="block font-medium">{s.title}</span>
                      <span className="block text-xs text-muted-foreground">{s.tagline}</span>
                    </span>
                  </Link>
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>
        </nav>
        <div className="flex items-center gap-3">
          <ThemeToggle className="text-muted-foreground hover:text-foreground hover:bg-accent" />
          <a href="https://app.sistemaneurobit.com.br" className="hidden sm:inline text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
            Entrar
          </a>
          <a href="mailto:contato@sistemaneurobit.com.br">
            <Button className="bg-[#052e38] hover:bg-[#0a4552] text-white">Fale Conosco</Button>
          </a>
        </div>
      </div>
    </header>
  );
};
